var Panel           = require("../Panel"),
    $               = require("jquery");

var Legend = Panel.extend({

    statics: {
        create: function(options, translate){
            var legendClass;

            options || (options = {});

            if(
                !(options instanceof omjs.Project.Visualization) &&
                !($.isPlainObject(options))
            ){
                throw new TypeError('No `omjs.Project.Visualization` instance or `legend options` given')
            }

            return $.when()
                .then(function(){
                    if(options instanceof omjs.Project.Visualization){
                        return options.getLegend()
                    }

                    if($.isPlainObject(options)){
                        if(!('type' in options)){
                            options['type'] = 'category'
                        }
                        return options;
                    }
                })
                .then(function(legendOptions){
                    // if(legendOptions['name'] !== null){
                    //     legendOptions['name'] = options.get('name');
                    // }

                    if(!legendOptions['showLegend']){
                        return $.Deferred().reject();
                    } else if (!legendOptions['showValues'] && legendOptions['name'] == null) {
                        return $.Deferred().reject();
                    } else if (legendOptions['type'] == 'category' && options.get('render_type') == 1) {
                        //так как в категориях вектором нет настроек легенды, то не показываем ее
                        // return $.Deferred().reject();
                    }

                    switch(legendOptions['type']){
                        case 'bubble':
                            legendClass = require('./BubbleLegend');
                            break;
                        case 'category':
                            legendClass = require('./CategoryLegend');
                            break;
                        case 'thematic':
                            legendClass = require('./ThematicLegend');
                            break;
                        case 'heat':
                            legendClass = require('./HeatLegend');
			                break;
                        case 'PieChart':
                        case 'BarChart':
                        case 'LineChart':
                            legendClass = require('./ChartLegend');
                            break;
                    }
                    if (typeof translate == 'function') {
                        legendOptions['translate'] = translate;
                    }

                    if ($.isArray(legendOptions.classificators)){
                        legendOptions.classificators = legendOptions.classificators.filter(function(item){
                            return (item['value'] !== null);
                        });
                    }
                    else {
                        legendOptions.classificators = [];
                    }

                    return new legendClass(legendOptions);
                });
        }
    },

    initialize: function(options){
        var that = this;

        options || (options = {});

        options.classificators = options.classificators ? options.classificators : [];

        Legend.__super__.initialize.call(that, options);

        // Базовый класс Widget грохает опцию name. А она нам очень нужна.
        if(that._name){
            that.options.name = that._name;
        }

        that._container.addClass('omjs-legend');

        that._buildLegend();
    },

    _getTemplate: function(){
        return require("./template.ejs");
    },

    setClassificators: function(data) {
        var that = this;

        that.options.classificators = $.isArray(data) ? data : [];
        that._buildLegend();

        return that;
    },

    setName: function(name) {
        var that = this;

        that.options.name = $.type(name) !== "string"
            ? name
            : '';

        that._buildLegend();

        return that;
    },

    _buildLegend: function(){
        var that = this;

        var htm = that._getTemplate()(that.options);
        // если name для легенды не задан в шаблоне появляется какая то магическая цифра
        if (!that.options.name) {
            that.options.name = '';
        }

        that.getContentContainer().html(htm);
    }
});

module.exports = Legend;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/Legend/Legend.js
// module id = 210
// module chunks = 0